import { clinicianSearchClearQueryParams } from 'client-portal/utils/clinicianSearch/facets/manifest';
import { tracked } from '@glimmer/tracking';
import Service, { service } from '@ember/service';

/**
 * Mobile-only UI chrome for clinician search:
 *  - visibility of the secondary mobile header rendered by the parent
 *    request templates (out of reach of the clinician-search controller)
 *  - the mobile filters overlay state (open/closed, active detail key,
 *    clear-all action)
 *
 * Access only via clinicianSearch.mobile, not as a top-level service.
 */
export default class ClinicianSearchMobileService extends Service {
  @service clinicianSearch;

  @tracked isHeaderVisible = true;
  @tracked isFiltersOverlayOpen = false;
  @tracked activeDetailKey = null;

  resetState() {
    this.isHeaderVisible = true;
    this.isFiltersOverlayOpen = false;
    this.activeDetailKey = null;
  }

  hideHeader = () => (this.isHeaderVisible = false);
  showHeader = () => (this.isHeaderVisible = true);

  openFiltersOverlay = () => {
    this.isFiltersOverlayOpen = true;
    this.activeDetailKey = null;
  };

  closeFiltersOverlay = () => {
    this.isFiltersOverlayOpen = false;
    this.activeDetailKey = null;
  };

  toggleFiltersOverlay = () => {
    this.isFiltersOverlayOpen ? this.closeFiltersOverlay() : this.openFiltersOverlay();
  };

  applyAndCloseFiltersOverlay = () => {
    this.closeFiltersOverlay();
  };

  openFilterDetail = key => {
    this.activeDetailKey = key;
    this.clinicianSearch.trackFilterTypeSelected(key);
  };

  backFromDetail = () => {
    this.activeDetailKey = null;
  };

  clearFilters = () => {
    this.clinicianSearch.query.applySearchFilter(clinicianSearchClearQueryParams());
    this.activeDetailKey = null;
  };
}
